import { render, staticRenderFns } from "./BreederForm.vue?vue&type=template&id=23581452&"
import script from "./BreederForm.vue?vue&type=script&lang=js&"
export * from "./BreederForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports